<template>
  <div class="headTop">
    <nav class="headTop_nav">
      <p>广鹏兴公司官网</p>
      <div class="title_des"></div>
      <ul>
        <li :class="{active: currentIndex == 'b-index'}" @click="linkTo('b-index')">
          <span >首页</span>
        </li>
        <li @click="linkTo('b-aboutUs')" :class="{active: currentIndex == 'b-aboutUs'}">
          <span>知识分享</span>
        </li>
        <!-- <li @click="linkTo('b-bussIntro')" :class="{active: currentIndex == 'b-bussIntro'}">
          <span>业务介绍</span>
          <ul class="muen">
            <li class="muen_list">业务简介</li>
            <li class="muen_list">业务模式</li>
            <li class="muen_list">业务流程</li>
          </ul>
        </li>
        <li @click="linkTo('b-pdtsolutions')" :class="{active: currentIndex == 'b-pdtsolutions'}">
          <span>产品及解决方案</span>
          <ul class="muen">
            <li class="muen_list">国内贸易融资解决方案</li>
          </ul>
        </li> -->
        <!-- <li @click="linkTo('b-baiKe')" :class="{active: currentIndex == 'b-baiKe'}">
          <span>保理法律法规</span>
        </li> -->
        <li @click="linkTo('b-news')" :class="{active: currentIndex == 'b-news'}">
          <span>最新文章</span>
          <!-- <ul class="muen">
            <li class="muen_list">益安要闻</li>
            <li class="muen_list">行业热点</li>
          </ul> -->
        </li>
        <li  @click="linkTo('b-contact')" :class="{active: currentIndex == 'b-contact'}">
          <span>留言</span>
        </li>
        <!-- <li @click="linkTo('b-join')" :class="{active: currentIndex == 'b-join'}" class="noRightBorder">诚聘英才
        </li> -->
      </ul>
    </nav>
    <div class="headTop_banner">
      <div class="banner_text">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentIndex: this.$router.currentRoute.name // 默认当前页
    }
  },
  methods: {
    linkTo (name) {
      this.currentIndex = name
      this.$router.push({name: name})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../styles/font.styl'
gloalWidth = 1200px
.active
  color globalFontColor !important
.headTop_nav
  width 80%
  height 18px
  margin 0 auto
  margin-top 50px
  position relative
  p
    position absolute
    font-family STXinwei
    font-size 40px
    font-weight bold
    color globalFontColor
    top 0px
    left -5%
  >img
    width 45px
    height 45px
    position absolute
    top -30%
    left -19%

  .title_des
    height 40px
    border-left 1px solid #cccccc
    position absolute
    color #cccc
    line-height: 40px;
    padding-left: 20px;
    top 0px
    left 120px
  ul
    width 70%
    float right
    overflow hidden
    margin-top: 10px;
    li
      float left
      width 150px
      text-align center
      line-height @height
      color #999999
      cursor pointer
      &:hover .muen
        height 100%
      span
        display inline-block
        width @width
        border-right 1px solid #999999

.headTop_banner
  width 100%
  height 450px
  margin 0 auto
  margin-top 50px
  background: url(../../assets/index/u34.jpg) no-repeat center center;
  background-size 100% 100%
  position relative
  .banner_text
    position absolute
    top 380px
    left 50px
    color globalFontColor
    font-family STXinwei
    p:nth-child(1)
      font-size 30px
      font-style italic
.noRightBorder
  border-right none !important
.muen
  position relative
  z-index 1
  color: #fff
  top 5px
  height 0
  background: #42464e;
  border-radius: 0 0 6px 6px;
  box-shadow: 2px 2px 6px rgba(0,0,0,.3);
  overflow: hidden;
  li
    padding 2px 0
    margin-bottom 5px
    &:hover
      color #ffffff
      opacity 1
</style>
